<template>
  <div class="fukidashi-base" :style="{padding: boxPadding}" :class="{reverse: this.arrowDirection !== 'left'}">
    <svg xmlns='http://www.w3.org/2000/svg' :height="bodyHeight" :width="bodyWidth" :viewBox="`0 0 ${bodyWidth} ${bodyHeight}`" :style="fukiStyle"><!-- 背景色と枠線を指定 -->
      <path :d="pathString"></path>
    </svg>
    <p ref="inner-text">{{fukiText}}</p>
  </div>
</template>

<script>
export default {
  name: 'FukidashiBase',
  props: {
    fukiText: {
      type: String,
      default: ''
    },
    arrowDirection: {
      type: String,
      default: 'left'
    }
  },
  data(){
    return {
      padLeft: 25,
      cornerRadius: 20,
      bodyWidth: 200,
      bodyHeight: 80,
    }
  },
  computed: {
    boxPadding(){
      const side = 20
      const vertical = 20
      if(this.arrowDirection === 'left'){
        return `${vertical}px ${side}px ${vertical}px ${this.padLeft + side}px`
      }else {
        return `${vertical}px ${this.padLeft + side}px ${vertical}px ${side}px`
      }
    },
    boxHeight(){
      return 100
    },
    boxWidth(){
      return 220
    },
    fukiStyle(){
      return 'fill:#ffffff;stroke:#dadada'
    },
    textHeight(){

    },
    pathString(){
      //const baseString = 'M15,6 A6 6 0 0 1 21,1 L170,1 A6,6 0 0 1 175,6 L175,42 A6,6 0 0 1 170,48 L21,48 A6,6 0 0 1 15,42 L15,40 L1,45 L15,25  Z'

      const border = 1
      const bodyW = this.bodyWidth
      const bodyH = this.bodyHeight  - border
      const padL = this.padLeft
      const corner = this.cornerRadius
      const fukiW = bodyW - padL - corner
      const posR = `${fukiW + padL + corner - border}`
      const baseH = bodyH - corner
      const arrowT = bodyH - 40
      const arrowB = arrowT + 18
      const arrowEdge = arrowT

      const arcLT = `M${padL},${corner} A${corner} ${corner} 0 0 1 ${padL + corner},${border}`
      const lineT = `L${padL + fukiW},1`
      const arcRT = `A${corner},${corner} 0 0 1 ${posR},${corner}`
      const lineR = `L${posR},${baseH}`
      const arcRB = `A${corner},${corner} 0 0 1 ${padL + fukiW},${bodyH}`
      const lineB = `L${padL + corner},${bodyH}`
      const arcLB = `A${corner},${corner} 0 0 1 ${padL},${baseH}`
      const arrow = `L${padL},${arrowB} L1,${arrowEdge} L${padL},${arrowT}`

      // 描画まとめ
      const draw = `${arcLT} ${lineT} ${arcRT} ${lineR} ${arcRB} ${lineB} ${arcLB} ${arrow} z`
      // console.log('draw: [%s]', draw)
      return draw

    }
  },
  mounted() {
    this.resetSize()
    window.addEventListener('resize', this.resetSize)
  },
  methods: {
    resetSize(){
      this.$nextTick(()=>{
        this.bodyWidth = this.$el.clientWidth
        this.bodyHeight = this.$el.clientHeight
      })
    }
  }
}</script>

<style scoped lang="scss">
.fukidashi-base {
  width: 100%;
  min-height: 100px;
  position: relative;
  svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
  }
  &.reverse {
    svg {
      transform: scale(-1, 1);
    }
  }
  p {
    position: relative;
    z-index: 10;
    text-align: left;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/utvStore/components/recommend/line_special/partials/FukidashiBase.vue